import { type z } from 'zod';

import { CreateUserResourceLinkTypeSchema } from './create-user-resource-link-type.dto';

export const UpdateUserResourceLinkTypeSchema =
  CreateUserResourceLinkTypeSchema.partial();

export type IUpdateUserResourceLinkTypeDto = z.infer<
  typeof UpdateUserResourceLinkTypeSchema
>;
